import React from 'react';
import cn from "classnames";
import preloader from "../../../assets/images/preloader.svg";
import style from './LoadingArea.module.css';

/**
 * Обёртка списка на время загрузки: предыдущее содержимое остаётся на месте
 * (приглушённое), индикатор рисуется поверх. Ничего не вставляется в поток
 * вёрстки, поэтому при смене страницы ничего не прыгает.
 */
const LoadingArea = ({loading, children, className}) => (
    <div className={cn(style.area, {[style.loading]: loading}, className)} aria-busy={loading || undefined}>
        <div className={style.content}>{children}</div>
        {loading ? (
            <div className={style.indicator}>
                <img src={preloader} alt="Загрузка" width="48" height="48"/>
            </div>
        ) : null}
    </div>
);

export default LoadingArea;
